import { Injectable } from '@angular/core';

import { Product } from './product';
import { PRODUCTS } from './products';
import { MOCKPRODUCTS } from './mock-products';

@Injectable()
export class ProductsService {

  getProducts(): Promise<Product[]> {
    return Promise.resolve(PRODUCTS);
  }

  getMockProducts(): Promise<Product[]> {
    return Promise.resolve(MOCKPRODUCTS);
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/business-areas/products/products.service.ts